import styled from "@emotion/styled";
import MenuItem from "./MenuItem";
import UserOptionSelector from "./UserOptionSelector";
import NewButton from "./NewButton";
import { Logo } from "src/components/Logo";
import { Link } from "react-router-dom";
import { SECONDARY_GREY } from "src/constants/colors";

export const LeftDrawerContainer = styled.div`
  transition: width 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const NewButtonContainer = styled.div`
  padding: 0 0 0 20px;
  margin-bottom: 24px;
`;

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const BottomMenuContainer = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${SECONDARY_GREY};
  margin: 24px 0 24px 20px;
`;

export const PorchPassLogo = styled.div`
  height: 32px;
  margin: 24px 20px;
  width: 130px;
`;

export const LogoLink = styled(Link)`
  text-decoration: none;

  & > img {
    max-height: 32px;
    max-width: 130px;
  }
`;

interface LeftDrawerProps {
  page: string;
  userInfo: { is_admin?: boolean };
  dealer_id: string;
}

export default ({ page, userInfo, dealer_id }: LeftDrawerProps) => (
  <LeftDrawerContainer>
    <PorchPassLogo>
      <LogoLink to={`/${dealer_id}`}>
        <Logo />
      </LogoLink>
    </PorchPassLogo>
    <NewButtonContainer>
      <NewButton />
    </NewButtonContainer>
    <MenuContainer>
      <MenuItem forPage={"dashboard"} isCurrent={page === "dashboard"} />
      <MenuItem
        forPage={"applications"}
        isCurrent={page === "applications" || page === "application-details"}
      />
      <MenuItem forPage={"employees"} isCurrent={page === "employees"} />
      {userInfo.is_admin && (
        <MenuItem forPage={"dealers"} isCurrent={page === "dealers"} />
      )}
    </MenuContainer>
    <BottomMenuContainer>
      <MenuItem forPage={"resources"} isCurrent={page === "resources"} />
      <Divider />
    </BottomMenuContainer>
    <UserOptionSelector />
  </LeftDrawerContainer>
);
